import { RemoteGetCheckProfessionalExists } from 'data/usecases';
import { GetAllCheckProfessionalExistsUseCaseInterface } from 'domain/usecases';
import { makeApiUrlCheckProfessionalExists } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetCheckProfessionalExists =
  (): GetAllCheckProfessionalExistsUseCaseInterface =>
    new RemoteGetCheckProfessionalExists(
      makeApiUrlCheckProfessionalExists(),
      makeAxiosHttpClient(),
    );
